'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flip = exports.Zoom = exports.Slide = exports.Bounce = undefined;

var _cssTransition = require('./../utils/cssTransition');

var _cssTransition2 = _interopRequireDefault(_cssTransition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bounce = (0, _cssTransition2.default)({
  enter: 'Toastify__bounce-enter',
  exit: 'Toastify__bounce-exit',
  appendPosition: true
});

var Slide = (0, _cssTransition2.default)({
  enter: 'Toastify__slide-enter',
  exit: 'Toastify__slide-exit',
  duration: [450, 750],
  appendPosition: true
});

var Zoom = (0, _cssTransition2.default)({
  enter: 'Toastify__zoom-enter',
  exit: 'Toastify__zoom-exit'
});

var Flip = (0, _cssTransition2.default)({
  enter: 'Toastify__flip-enter',
  exit: 'Toastify__flip-exit'
});

exports.Bounce = Bounce;
exports.Slide = Slide;
exports.Zoom = Zoom;
exports.Flip = Flip;


//////////////////
// WEBPACK FOOTER
// ./~/react-toastify/lib/components/Transitions.js
// module id = 754
// module chunks = 0